import { IPromotionUiCart, IPromotionUiCartInput } from '../../interfaces'
import { getActivePromotionsFields } from '../common/getPromotionFields'
import formatPromotionMessage, {
  IFormatPromotionMessage,
} from '../formatPromotionMessage'
import formatPercentage from '../formatPercentage'

export const getVolumePromotionUiDetails = ({
  cartProduct,
  activePromotion,
  config,
}: IPromotionUiCartInput): IPromotionUiCart | undefined => {
  const texts = config?.texts?.cartPromotions
  const { discounts, quantity, price, sku } = cartProduct
  const consumedQty = activePromotion.itemsConsumed?.[sku] ?? quantity
  const giftMergedIntoLine = consumedQty < quantity
  const validDiscounts = discounts || 0
  const {
    fields: { customerGetsPercentage, customerGetsCash, type },
    promotion,
  } = getActivePromotionsFields(activePromotion)
  if (customerGetsCash) {
    return undefined
  }
  const promotionPercentageFormat = config?.options?.promotionPercentageFormat

  const percentage = formatPercentage(
    customerGetsPercentage,
    promotionPercentageFormat,
  )

  const { volumeDefaultLabel, defaultSaving } = texts || {}
  const formatArgs: IFormatPromotionMessage = {
    message: '',
    promotion,
    config,
    saving: validDiscounts,
    amount: validDiscounts,
    placeholders: {
      discount: percentage,
      count: String(consumedQty),
    },
  }
  const label = formatPromotionMessage({
    ...formatArgs,
    message: volumeDefaultLabel as string,
  })

  const result: IPromotionUiCart = { label, type }

  if (validDiscounts) {
    // When a combo gift unit is merged into this SKU's line, `discounts` bundles
    // the gift's full price together with the volume discount, so averaging it
    // across the line misreports both the per-unit price and the saving. In that
    // case recompute the per-unit price from the volume percentage, and the saving
    // as the volume discount on the consumed units only; otherwise keep the
    // discount-derived figures verbatim.
    const value = giftMergedIntoLine
      ? price * (1 - customerGetsPercentage)
      : price - validDiscounts / quantity
    const saving = giftMergedIntoLine
      ? consumedQty * (price - value)
      : validDiscounts

    result.saving = formatPromotionMessage({
      ...formatArgs,
      saving,
      amount: saving,
      message: defaultSaving as string,
    })

    result.value = value
  }

  return result
}
